import type { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { Tag } from '@catalyze/ui';

type ICheckboxMenuTagsProps = {
    inputName: string;
    map: Array<{ value: string | null; label: string }>;
};

export const CheckboxMenuTags: FC<ICheckboxMenuTagsProps> = ({
    inputName,
    map,
}) => {
    const { setValue } = useFormContext();
    const {
        field: { value: values },
    } = useController<Record<typeof inputName, Array<string | null>>>({
        name: inputName,
    });

    if (!values) {
        return null;
    }

    return (
        <>
            {values
                .map((val) => map.find((mapRecord) => mapRecord.value === val))
                .map(
                    (val) =>
                        val && (
                            <Tag
                                key={val.value}
                                value={val.label}
                                onDelete={() =>
                                    setValue(
                                        inputName,
                                        values.filter(
                                            (record) => record !== val.value
                                        )
                                    )
                                }
                            />
                        )
                )}
        </>
    );
};

CheckboxMenuTags.defaultProps = {};
